// extracted by mini-css-extract-plugin
export default {"buttonDiv":"NextButton_buttonDiv__9YNmB","buttonNext":"NextButton_buttonNext__j3Mew"};